import { Reducer } from 'redux';
import { IAction } from '../types';
import { purchaseInfoJson, configInfoJson } from '@/views/system/transaction/myBox/purchase/typings';
import LocalStore from '@/utils/store';

export interface TransationState {
  myBoxBreadCrumbState: number;
  purchaseInfo: purchaseInfoJson;
  configInfo: configInfoJson;
  myBoxInfoState: number;
  chargeToken: string;
}

const localGameInfo = LocalStore.getValue<TransationState>('TRANSATION_MYBOX_COM_STATE') || {};

export const defaultUser: TransationState = {
  myBoxBreadCrumbState: 0,
  purchaseInfo: {
    gameId: '',
    gameName: '',
    gameLogo: '',
    serverId: '',
    serverName: ''
  },
  configInfo: {
    roleId: '',
    coinId: '',
    equip_type_id: ''
  },
  myBoxInfoState: 0,
  chargeToken: '',
  ...localGameInfo
};

export const setTransationInfo: (payload: TransationState) => IAction<TransationState> = (
  payload: TransationState
) => ({
  type: 'setTransationInfo',
  payload
});

const noticeReducer: Reducer<TransationState, IAction<any>> = (state = defaultUser, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setTransationInfo':
      LocalStore.setValue('TRANSATION_MYBOX_COM_STATE', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default noticeReducer;
